import {
  SuggestedVariantOptionsInputSchema,
  SuggestedVariantOptionsSchema,
} from "@redotech/redo-model/agents/suggested-variant-options/suggested-variant-options";

export const getSuggestedVariantOptions = {
  input: SuggestedVariantOptionsInputSchema,
  output: SuggestedVariantOptionsSchema,
};
